module.exports = __webpack_public_path__ + "img/测点_门区开关.c9f1a779.png";